import { render } from "./Robot.vue?vue&type=template&id=69e06b02&scoped=true"
import script from "./Robot.vue?vue&type=script&lang=js"
export * from "./Robot.vue?vue&type=script&lang=js"

import "./Robot.vue?vue&type=style&index=0&id=69e06b02&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-69e06b02"

export default script